import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, requireSchool = true }) => {
  const { loading, isAuthenticated, hasSchool } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-neutral-50 dark:bg-neutral-950 flex items-center justify-center font-medium text-neutral-500 dark:text-neutral-400">
        Verifying Session Profile Security...
      </div>
    );
  }

  // Phase 1: Bounce back to portal landing if unauthorized
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Phase 2: If authorized but setup form is pending, vector to profile builder
  if (requireSchool && !hasSchool) {
    return <Navigate to="/school-setup" replace />;
  }

  // Phase 3: If school profile exists, do not allow user to access setup screens again
  if (!requireSchool && hasSchool) {
    return <Navigate to="/school-home" replace />;
  }

  return children;
};

export default ProtectedRoute;
